import script from "./reports.vue?vue&type=script&setup=true&lang=js"
export * from "./reports.vue?vue&type=script&setup=true&lang=js"

import "./reports.vue?vue&type=style&index=0&id=a232516c&scoped=true&lang=css"

import exportComponent from "/home/runner/work/inventflux-frontend/inventflux-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a232516c"]])

export default __exports__